var _path, _path2, _mask, _g, _mask2, _g2, _mask3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M32.994 25.293c-1.089-2.709-2.518-5.642-5.712-6.17-.709-.117-4.827-.124-5.637.026-3.063.573-4.92 3.374-6.422 5.955l-.304.525c-.223.383-.26.84-.1 1.255l2.437 6.303c.14.363.414.65.771.807.357.157.752.167 1.11.026.363-.14.65-.412.807-.77.158-.356.167-.75.027-1.112l-2.185-5.651c1.219-2.088 2.564-4.134 4.386-4.475.49-.083 4.131-.096 4.636-.016 1.538.254 2.473 1.865 3.484 4.382l3.474 8.638c.223.554.753.913 1.35.913.184 0 .366-.035.543-.105.36-.145.643-.422.796-.78.152-.357.156-.753.011-1.113l-3.472-8.638zM23.938 12.773c0-1.121.912-2.035 2.034-2.035 1.122 0 2.035.914 2.035 2.035 0 1.122-.913 2.035-2.035 2.035s-2.034-.913-2.034-2.035m2.034 4.946c2.727 0 4.946-2.218 4.946-4.946 0-2.727-2.22-4.945-4.946-4.945-2.727 0-4.946 2.218-4.946 4.946 0 2.727 2.22 4.945 4.946 4.945M24.355 35.02c-.368-.126-.762-.1-1.111.072-.35.174-.61.473-.734.84l-3.953 11.663c-.012.033-.02.067-.032.113l-.064.347.022.007v.024c0 .034.001.068.006.11l.005.05c.004.027.008.055.016.091l.03.126.029.088.016.043c.01.026.023.055.032.075l.133.226c.016.024.031.045.083.108l.061.068.258.21c.026.016.051.032.077.045l.018.01-.002.017.415.15.008-.017c.036.007.072.012.123.017.044.005.087.008.153.008h2.967c.803 0 1.456-.653 1.456-1.455s-.653-1.455-1.456-1.455h-.944l3.299-9.735c.124-.368.099-.763-.073-1.112-.172-.348-.47-.608-.838-.733z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M32.006 46.6h-1.692L27.73 26.264c-.05-.387-.247-.73-.556-.97-.313-.24-.692-.345-1.072-.29-.796.102-1.361.832-1.26 1.627l2.725 21.433-.006.004.046.301-.003.004.115.337h.014c.013.027.026.052.041.076l.36.45.017-.023.093.065c.026.017.053.035.067.04l.051.03c.022.01.044.022.115.053l-.003.019.463.107.005-.019c.026.002.057.003.094.003h2.97c.803 0 1.456-.652 1.456-1.455s-.653-1.456-1.456-1.456z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "3gfukwwn8a",
    width: 3,
    height: 11,
    x: 4,
    y: 40,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 40.107h2.693v9.936H4v-9.936z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3gfukwwn8a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M5.346 50.043C4.603 50.043 4 49.44 4 48.696v-7.243c0-.744.603-1.346 1.346-1.346.744 0 1.347.602 1.347 1.346v7.243c0 .744-.603 1.347-1.347 1.347",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "we7mu0bfsb",
    width: 42,
    height: 34,
    x: 4,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 .043h41.994v33.455H4V.043z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#we7mu0bfsb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M5.346 33.498C4.603 33.498 4 32.895 4 32.15V3.713C4 1.69 5.646.043 7.67.043h34.654c2.024 0 3.67 1.647 3.67 3.67v11.095c0 .744-.603 1.347-1.346 1.347-.744 0-1.347-.603-1.347-1.347V3.713c0-.538-.439-.977-.977-.977H7.67c-.538 0-.977.439-.977.977v28.438c0 .744-.603 1.347-1.347 1.347",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "2bdduq2m6c",
    width: 3,
    height: 27,
    x: 43,
    y: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.3 24.768h2.694v25.275H43.3V24.768z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2bdduq2m6c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M44.647 50.043c-.744 0-1.346-.602-1.346-1.346V26.113c0-.743.602-1.345 1.346-1.345.744 0 1.347.602 1.347 1.345v22.584c0 .744-.603 1.346-1.347 1.346",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceso);
export default __webpack_public_path__ + "static/media/acceso.d2269be223aca56732aa56c5c74e323b.svg";
export { ForwardRef as ReactComponent };